import _ from 'lodash';

let initCourses = {
	expires: 0,
	fetching: false,
	fetching_from: null,
	fetching_to: null,
	fetching_singles: [],
	from: null,
	to: null,
	data: [],
	singles: {},
	singles_errors: {}
}

const courses = (state = initCourses, action) => {
	switch (action.type) {
		case 'LOGIN_SUCCESS':
		case 'LOGOUT_SUCCESS':
			return initCourses;
		case 'COURSES_REQUEST':
			return {...state, fetching: true, fetching_from: action.extra.from, fetching_to: action.extra.to};
		case 'COURSES_SUCCESS':
			const expires = Math.floor(Date.now() / 1000) + 3600; // current time + 1 hr
			const f = (state.from === null || action.extra.from < state.from) ? action.extra.from : state.from;
			const t = (state.to === null || action.extra.to > state.to) ? action.extra.to : state.to;
			const c = _.unionBy(state.data, action.response, 'code');
			return {...state, expires: expires, data: c, fetching: false, from: f, to: t, fetching_from: null, fetching_to: null  }
		case 'COURSES_FAILURE':
			return {...state, fetching: false, fetching_from: null, fetching_to: null};
		case 'COURSE_REQUEST':
			const cr = _.union(state.fetching_singles, [action.extra.course_code])
			const ser = _.omit(state.singles_errors, action.extra.course_code);
			return {...state, fetching_singles: cr, singles_errors: ser }
		case 'COURSE_SUCCESS':
			const exp = Math.floor(Date.now() / 1000) + 3600; // current time + 1 hr
			const cs = _.without(state.fetching_singles, action.response.code)
			const s = {...state.singles, [action.response.code]: action.response}
			return {...state, fetching_singles: cs, singles: s, expires: exp}
		case 'COURSE_FAILURE':
			const cf = _.without(state.fetching_singles, action.extra.course_code)
			const sef = {...state.singles_errors, [action.extra.course_code]: action.error}
			
			console.log(sef);
			
			return {...state, fetching_singles: cf, singles_errors: sef }
		default:
			return state;
	}
}

export default courses